import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_URL: z.url(),
  VITE_APP_NAME: z.string().default('mir-ai'),
  VITE_ENV: z.enum(['development', 'staging', 'production']),
  VITE_USE_MOCKS: z.enum(['true', 'false']).default('false'),
  /** Door assistant on the plan page; core-service needs ASSISTANT_ENABLED and the orchestrator Bedrock access. */
  VITE_ASSISTANT: z.enum(['true', 'false']).default('false'),
  /** Optional DSN for client-side error reporting (Sentry-compatible). */
  VITE_SENTRY_DSN: z.string().optional(),
  /** Optional PostHog project key. When set, the analytics adapter
   *  routes events to PostHog; otherwise events go to a no-op/console adapter. */
  VITE_POSTHOG_KEY: z.string().optional(),
  /** Override the PostHog ingest host (e.g. EU region). Default: app.posthog.com. */
  VITE_POSTHOG_HOST: z.string().optional(),
});

export type Env = z.infer<typeof EnvSchema>;

export function parseEnv(raw: Record<string, unknown>): Env {
  const result = EnvSchema.safeParse(raw);
  if (!result.success) {
    const formatted = result.error.issues
      .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
      .join('\n');
    throw new Error(`Invalid environment variables:\n${formatted}`);
  }
  return result.data;
}

export const env: Env = parseEnv(import.meta.env);
